'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _isEqual = require('is-equal');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _pify = require('pify');

var _pify2 = _interopRequireDefault(_pify);

var _pinkiePromise = require('pinkie-promise');

var _pinkiePromise2 = _interopRequireDefault(_pinkiePromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	onSuccess: {
		type: 'function'
	},
	options: {
		type: 'object'
	},
	siteKey: {
		type: 'string'
	}
};

var defaultProps = {
	onExpire: function onExpire() {},
	onSuccess: function onSuccess() {},
	options: {},
	siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	url: 'https://www.google.com/recaptcha/api.js'
};

var callback = function callback(onSuccess) {
	return function (res) {
		return onSuccess && onSuccess(res);
	};
};
var onLoad = function onLoad(el, obj) {
	return function () {
		return window.grecaptcha.render(el, obj);
	};
};

var loadReCaptcha = function loadReCaptcha(url, onLoadVar) {
	if (window.grecaptcha) {
		window[onLoadVar]();
		return _pinkiePromise2.default.resolve();
	}

	return (0, _pify2.default)(_loadScript2.default, { promiseModule: _pinkiePromise2.default })(url + '?render=explicit&onload=' + onLoadVar);
};

var afterRender = function afterRender(_ref, el) {
	var id = _ref.id,
	    props = _ref.props;
	var onExpire = props.onExpire,
	    onSuccess = props.onSuccess,
	    options = props.options,
	    siteKey = props.siteKey,
	    url = props.url;

	var onLoadVar = '_dekuRecaptchaLoad' + id;
	var obj = (0, _objectAssign2.default)({
		'expired-callback': onExpire,
		callback: callback(onSuccess),
		sitekey: siteKey
	}, options);

	window[onLoadVar] = onLoad(el, obj);
	loadReCaptcha(options.url || url, onLoadVar).catch(console.err);
};

var shouldUpdate = function shouldUpdate(_ref2, nextProps) {
	var props = _ref2.props;
	return !(0, _isEqual2.default)(props, nextProps);
};
var beforeUnmount = function beforeUnmount() {
	return window.grecaptcha && window.grecaptcha.reset();
};
var render = function render(_ref3) {
	var props = _ref3.props;
	return (0, _magicVirtualElement2.default)('div', { 'class': ['ReCaptcha', props.class] });
};

exports.default = { afterRender: afterRender, beforeUnmount: beforeUnmount, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
